import { graphql } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import Framework from '../components/framework';
import Breadcrumb from '../components/framework/breadcrumb';
import Trans from '../components/translation/trans';
import useTranslation from '../hooks/use_translation';
import { getVariantByLanguage } from '../utils/helpers';

const Partner = ({ data, location }) => {
	const article = data.article;
	const { language, t } = useTranslation('template_partner');
	const variant = getVariantByLanguage(language, article.article_variants);
	const image_logo = article?.fields?.files_logo_url_src;

	return (
		<Framework
			description={variant.seo_description}
			location={location}
			tags={variant.seo_keywords}
			title={variant.seo_title}
		>
			<div className="container px-0 mt-3" id="content">
				<nav aria-label="breadcrumb mb-2">
					<Breadcrumb
						className="mb-3"
						links={[{ active: true, title: variant.title }]}
						partner={true}
					/>
				</nav>
			</div>
			<div className="container">
				<div className="row">
					<div className="col-lg-8">
						<h1 className="title-medium fw-700">{variant.title}</h1>
						<div className="bg-gray-100 p-3 text-center rounded-3 mb-3">
							<GatsbyImage
								alt="Partner header"
								className="img-fluid mx-auto text-center"
								image={getImage(image_logo)}
							/>
						</div>
						<p className="lead">{variant.excerpt}</p>
						<div className="article-content article-content-partner">
							<Trans defaults={variant.content} t={t} />
						</div>
					</div>
				</div>
			</div>
		</Framework>
	);
};

Partner.propTypes = {
	data: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
};

export default Partner;

export const pageQuery = graphql`
	query PartnerById($id: String!) {
		article(id: { eq: $id }) {
			fields {
				files_logo_url_src {
					childImageSharp {
						gatsbyImageData(width: 320)
					}
				}
			}
			type
			article_variants {
				content
				excerpt

				language {
					code
				}
				seo_description
				seo_keywords
				seo_title
				slug
				title
			}
		}

		locales: allLocale {
			...translationFields
		}
	}
`;
